module.exports = __webpack_public_path__ + "static/media/number3.a65313a5.svg";